<div class="modal-header bg-soft-info p-3">
    <h5  class="modal-title" id="exampleModalLabel" i18n="@@" >{{documentName}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        id="close-modal" (click)="close()"></button>
</div>
<div class="card-body p-3">
    <div class="text-center">
        
       <!-- <iframe  style="width: 90vw; height: 90vh; overflow: scroll;" src ='openViewString' [routerLink]="openViewString">

       </iframe> -->
    </div>
</div>
